<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">{{modifierGroupId ? 'Edit Modifier Group' : 'Add Modifier Group'}}</ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 220px)'}"
                   [styleClass]="'app-scrollpanel'">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <div *ngIf="activeTab===editModifierGroupTab.GroupInfo" style="padding: 10px">
            <div class="field">
                <div>Restaurant</div>
                <p-dropdown [options]="restaurants"
                            [(ngModel)]="modifierGroup.RestaurantId"
                            [optionLabel]="'Name'"
                            [optionValue]="'Id'"
                            [filter]="true"
                            [filterBy]="'Name'"
                            [style]="{width:'100%'}"
                            placeholder="Select Restaurant"
                            [disabled]="modifierGroupId !== 0 || modifierGroup.RestaurantId"
                            [showClear]="false">
                </p-dropdown>
            </div>
            <div class="field">
                <div>Name</div>
                <input pInputText class="edit-mod-group-field" [(ngModel)]="modifierGroup.Name" />
            </div>
            <div class="field">
                <div>Description</div>
                <input pInputText class="edit-mod-group-field" [(ngModel)]="modifierGroup.Description" />
            </div>
            <div class="field">
                <div>Plu</div>
                <input pInputText class="edit-mod-group-field" [(ngModel)]="modifierGroup.Plu" />
            </div>
            <div class="field">
                <p-checkbox [(ngModel)]="isEnabled"
                            [binary]="true"
                            [label]="'Enabled'"></p-checkbox>
            </div>
            <div class="field">
                <div>MinSelection</div>
                <p-inputNumber [(ngModel)]="modifierGroup.MinSelection"></p-inputNumber>
            </div>
            <div class="field">
                <div>MaxSelection</div>
                <p-inputNumber [(ngModel)]="modifierGroup.MaxSelection"></p-inputNumber>
            </div>
        </div>

        <div *ngIf="activeTab===editModifierGroupTab.Modifiers && !modifierGroup.RestaurantId"
             style="padding: 10px; color: red">
            Please select restaurant
        </div>
        <div *ngIf="activeTab===editModifierGroupTab.Modifiers && modifierGroup.RestaurantId"
             style="padding: 10px">
            <p-dropdown [options]="freeModifiers"
                        [optionLabel]="'Name'"
                        [optionValue]="'Id'"
                        [filter]="true"
                        [filterBy]="'Name'"
                        [style]="{width:'100%'}"
                        placeholder="Add Modifier"
                        (onChange)="handleModifierSelected($event)"
                        [showClear]="true">
            </p-dropdown>
            
            <div style="height: 20px"></div>

            <p-table [columns]="cols"
                     [value]="groupModifiers"
                     [resizableColumns]="true"
                     [columnResizeMode]="'expand'"
                     [autoLayout]="true"
                     [styleClass]="'p-datatable-striped'"
                     [scrollable]="true"
                     [scrollHeight]="'flex'">
                <ng-template pTemplate="header">
                    <tr>
                        <th [pSortableColumn]="'Id'" pResizableColumn>Id <p-sortIcon field="Id"></p-sortIcon></th>
                        <th [pSortableColumn]="'Name'" pResizableColumn>Name <p-sortIcon field="Name"></p-sortIcon></th>
                        <th pResizableColumn>ImageUrl</th>
                        <th>Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-modifier>
                    <tr>
                        <td class="ui-resizable-column">{{modifier.Id}}</td>
                        <td class="ui-resizable-column">{{modifier.Name}}</td>
                        <td>
                            <a href="{{modifier.ImageUrl}}" target="_blank">
                                <img src="{{modifier.ImageUrl}}" width="100" />
                            </a>
                        </td>
                        <td>
                            <span class="action-icon-svg" (click)="handleDeleteModifierClick(modifier)">
                                <img src="../Content/xpress-app/images/svg/icon_cancel_yellow.svg" />
                            </span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-scrollPanel>

    <hr style="margin-left: -1rem; margin-right: -1rem;" />

    <div class="flex-row" style="padding-left: 10px; padding-right: 10px">
        <div>
            <button pButton
                    type="button"
                    label="Cancel"
                    class="p-button-danger"
                    (click)="handleSideBarHide()"></button>
        </div>

        <div class="filler"></div>

        <div>
            <button pButton
                    type="button"
                    label="{{modifierGroupId ? 'Save' : 'Create'}}"
                    class="edit-mod-group-btn"
                    (click)="handleSaveClick()"></button>
        </div>
    </div>
</p-sidebar>

<p-toast position="top-right"></p-toast>
